<template>
  <div class="d-flex justify-center align-center">
    <div class="upload-icon mr-2">
      <svg
        class="upload-folder"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        style="enable-background:new 0 0 24 24;"
        xml:space="preserve"
      >
        <path
          d="M20.33,4.17h-8.82L9.74,1.51C9.55,1.22,9.22,1.04,8.88,1.04H3.67c-1.73,0-3.12,1.4-3.12,3.12v14.58
    c0,1.73,1.4,3.12,3.12,3.12h4.44v-2.08H3.67c-0.58,0-1.04-0.47-1.04-1.04V4.17c0-0.58,0.47-1.04,1.04-1.04h4.65l1.77,2.66
    c0.19,0.29,0.52,0.46,0.87,0.46h9.38c0.58,0,1.04,0.47,1.04,1.04v11.46c0,0.58-0.47,1.04-1.04,1.04h-3.23v2.08h3.23
    c1.73,0,3.12-1.4,3.12-3.12V7.29C23.46,5.57,22.06,4.17,20.33,4.17z"
        />
      </svg>

      <svg
        version="1.1"
        class="upload-arrow"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        style="enable-background:new 0 0 24 24;"
        xml:space="preserve"
      >
        <path
          d="M12.38,13.75c-0.01,0-0.03,0.01-0.04,0.01c-0.01,0.01-0.03,0.01-0.04,0.02c-0.01,0.01-0.02,0.01-0.03,0.02
    c-0.01,0.01-0.02,0.02-0.04,0.02c-0.01,0.01-0.03,0.02-0.04,0.03c0,0-0.01,0.01-0.01,0.01l-3,3c-0.2,0.2-0.2,0.51,0,0.71l0.07,0.06
    c0.19,0.13,0.46,0.12,0.64-0.06l2.15-2.15l0,6.79c0,0.28,0.22,0.5,0.5,0.5l0.09-0.01c0.23-0.04,0.41-0.25,0.41-0.49l0-6.79
    l2.15,2.15c0.2,0.2,0.51,0.2,0.71,0s0.2-0.51,0-0.71l-3-3c-0.03-0.03-0.06-0.05-0.09-0.07c-0.01-0.01-0.02-0.01-0.04-0.02
    c-0.01-0.01-0.03-0.01-0.04-0.02c-0.01-0.01-0.03-0.01-0.04-0.01c-0.02,0-0.03-0.01-0.05-0.01c-0.01,0-0.02,0-0.03-0.01
    c-0.02,0-0.04,0-0.06-0.01c0,0-0.01,0-0.01,0c-0.04,0-0.07,0-0.1,0.01C12.42,13.74,12.4,13.74,12.38,13.75z"
        />
      </svg>
    </div>
    <span class="body-1 grey--text text--lighten-1 font-weight-bold">
      {{ $t('forms.sending') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'HUploading',
}
</script>

<style lang="scss" scoped>
.upload-icon {
  width: 24px;
  height: 24px;
  position: relative;
  margin-top: -2px;

  .upload-arrow {
    position: absolute;
    bottom: -5px;
    left: 0;
    animation: move 1.8s infinite;
    transform: scale(1.15);

    path {
      fill: #009dd9;
    }
  }

  .upload-folder {
    path {
      animation: hue 1.8s infinite;
    }
  }
}

@keyframes move {
  0% {
    opacity: 0;
    bottom: -5px;
  }
  60% {
    opacity: 1;
    bottom: 5px;
  }
  100% {
    opacity: 0;
    bottom: 8px;
  }
}

@keyframes hue {
  0% {
    fill: #cccccc;
  }
  60% {
    fill: #009dd9;
  }
  65% {
    fill: #009dd9;
  }
  100% {
    fill: #cccccc;
  }
}
</style>
